export const zh = {
  // Common
  common: {
    loading: '加载中...',
    error: '错误',
    save: '保存',
    cancel: '取消',
    delete: '删除',
    edit: '编辑',
    add: '添加',
    search: '搜索',
    back: '返回',
    close: '关闭',
    confirm: '确认',
    yes: '是',
    no: '否',
    ok: '确定',
    submit: '提交',
    reset: '重置',
    clear: '清除',
    view: '查看',
    details: '详情',
    settings: '设置',
    logout: '退出登录',
    login: '登录',
    signup: '注册',
    profile: '个人资料',
    collection: '收藏',
    insights: '洞察',
    overview: '概览',
    categories: '分类',
    preorders: '预订',
    recent: '最近',
    total: '总计',
    average: '平均',
    price: '价格',
    quantity: '数量',
    brand: '品牌',
    series: '系列',
    type: '类型',
    scale: '比例',
    source: '来源',
    date: '日期',
    status: '状态',
    value: '价值',
    items: '项目',
    owned: '拥有',
    preorder: '预订',
    created: '创建时间',
    updated: '更新时间',
    name: '名称',
    code: '代码',
    description: '描述',
    image: '图片',
    currency: '货币',
    language: '语言',
    preferences: '偏好设置',
    clone: '复制',
    cloneSuccess: '玩具复制成功',
    cloneError: '复制玩具失败',
    backToCollection: '返回收藏'
  },

  // Navigation
  nav: {
    home: '首页',
    collection: '收藏',
    insights: '洞察',
    wishlist: '愿望清单',
    settings: '设置',
    profile: '个人资料',
    logout: '退出登录',
    language: '语言',
    export: '导出'
  },

  // Landing Page
  landing: {
    title: 'ToyPort',
    subtitle: '终极玩具收藏管理工具',
    description: '轻松整理、跟踪和管理您的玩具和模型收藏。由收藏家为收藏家打造。',
    getStarted: '开始使用',
    signUp: '注册',
    goToCollection: '前往收藏',
    sampleCollection: '示例收藏',
    features: {
      title: '强大功能',
      subtitle: '管理收藏所需的一切',
      completeManagement: {
        title: '完整管理',
        description: '使用详细信息和分类添加、编辑和整理您的玩具。'
      },
      smartSearch: {
        title: '智能搜索',
        description: '通过强大的搜索和过滤功能快速找到您的玩具。'
      },
      multiCurrency: {
        title: '多货币',
        description: '通过自动转换支持以本地货币跟踪价格。'
      },
      preorderTracking: {
        title: '预订跟踪',
        description: '跟踪预订及其预期发布日期。'
      },
      cloudSync: {
        title: '云端同步',
        description: '您的收藏会自动在所有设备上同步。'
      },
      secure: {
        title: '安全私密',
        description: '您的数据经过加密且私密。只有您可以访问您的收藏。'
      }
    },
    howItWorks: {
      title: '使用方法',
      subtitle: '通过我们简单的4步流程在几分钟内开始',
      signUp: {
        title: '注册',
        description: '通过电子邮件或社交登录在几秒钟内创建您的免费账户。'
      },
      addToys: {
        title: '添加您的玩具',
        description: '使用我们易于使用的界面添加您现有的收藏。'
      },
      organize: {
        title: '整理',
        description: '对您的玩具进行分类和标记以便轻松管理。'
      },
      monitor: {
        title: '监控和跟踪',
        description: '跟踪您收藏的价值并获得关于您玩具的见解。'
      }
    },
    benefits: {
      title: '为什么选择ToyPort？',
      subtitle: '加入数千名信任ToyPort管理收藏的收藏家',
      neverLose: '永远不会丢失对收藏的跟踪',
      trackValue: '跟踪您收藏的总价值',
      planPurchases: '通过价格跟踪规划未来购买',
      shareCollection: '与朋友和家人分享您的收藏',
      mobileFriendly: '从任何设备访问您的收藏',
      freeToUse: '完全免费使用，无隐藏费用'
    },
    collectorTypes: {
      title: '适合所有收藏家',
      description: '无论您收藏高达、比例模型、动作人偶还是任何其他玩具，ToyPort都能满足您的需求。',
      startCollection: '开始您的收藏'
    },
    cta: {
      title: '准备好整理您的收藏了吗？',
      subtitle: '加入已经使用ToyPort整理收藏的数千名收藏家。',
      createAccount: '创建免费账户'
    }
  },

  // Collection
  collection: {
    title: '我的玩具收藏',
    addNewToy: '添加新玩具',
    searchPlaceholder: '按名称、代码、品牌或系列搜索...',
    noToys: '您的收藏中还没有玩具。',
    noSearchResults: '未找到符合搜索条件的玩具。',
    addFirstToy: '添加您的第一个玩具',
    showingResults: '显示 {total} 个玩具中的 {count} 个',
    endOfResults: '您已到达收藏的末尾',
    viewDetailedInsights: '查看详细洞察',
    summary: {
      title: '跟踪和整理您珍贵的玩具收藏',
      totalToys: '玩具总数',
      foundToys: '找到的玩具',
      totalValue: '总价值',
      averagePrice: '平均价格',
      totalQuantity: '总数量'
    },
    share: {
      description: 'Share a view-only link of your collection with friends or buyers.',
      copyLink: 'Copy public link',
      preview: 'Preview public page',
      copied: 'Public link copied to your clipboard.',
      copyFailed: 'Clipboard access is blocked. Copy this link manually: {url}',
      publishError: 'We could not refresh your public collection. Try again in a moment.',
      nothingToShare: 'Add at least one toy before sharing your collection.',
      publishing: 'Updating link…'
    },
    export: {
      title: 'Export Your Collection',
      subtitle: 'Download a backup of your toys for reports, inventory, or migration.',
      authRequired: 'You need to be signed in to export your collection.',
      loadError: 'We could not load your collection for export. Please try again.',
      empty: 'No toys to export yet. Add items to your collection first.',
      actionsTitle: 'Download files',
      actionsSubtitle: '{count, plural, one {1 item ready} other {{count} items ready}}',
      downloadCsv: 'Download CSV',
      downloadJson: 'Download JSON',
      fileHint: 'CSV works best in spreadsheets. JSON keeps all fields for data migration.',
      previewTitle: 'Preview (first {count} items)',
      previewSubtitle: '{total} total items · Prices in {currency}',
      previewFooter: '{remaining} more items not shown in preview.',
      headers: {
        name: 'Name',
        brand: 'Brand',
        series: 'Series',
        type: 'Type',
        scale: 'Scale',
        code: 'Code',
        quantity: 'Quantity',
        price: 'Price',
        priceCurrency: 'Price Currency',
        preorderPrice: 'Preorder Price',
        preorderPriceCurrency: 'Preorder Currency',
        source: 'Source',
        note: 'Notes',
        createdDate: 'Created Date'
      }
    }
  },

  // Toy Detail
  toyDetail: {
    newToy: '添加新玩具',
    editToy: '编辑玩具',
    name: '名称',
    code: '代码',
    codePlaceholder: '可选产品代码',
    brand: '品牌',
    series: '系列',
    type: '类型',
    scale: '比例',
    price: '价格',
    preorderPrice: '预订价格',
    quantity: '数量',
    source: '来源',
    imageUrl: '图片URL',
    createdDate: '创建日期',
    notes: '备注',
    save: '保存玩具',
    cancel: '取消',
    delete: '删除玩具',
    deleteConfirm: '您确定要删除这个玩具吗？',
    deleteConfirmDescription: '此操作无法撤销。',
    imagePlaceholder: '无图片'
  },

  // Insights
  insights: {
    title: '收藏洞察',
    subtitle: '关于您玩具收藏的详细分析和洞察',
    overview: {
      title: '概览',
      collectionStatus: '收藏状态',
      ownedItems: '拥有的项目',
      preorderItems: '预订项目',
      valueBreakdown: '价值分解',
      ownedValue: '拥有价值',
      preorderValue: '预订价值',
      mostValuableItems: '最有价值的项目'
    },
    categories: {
      title: '分类',
      topBrands: '热门品牌',
      topSeries: '热门系列',
      topTypes: '热门类型',
      topScales: '热门比例',
      topSources: '热门来源'
    },
    preorders: {
      title: '预订',
      preorderSummary: '预订摘要',
      items: '项目',
      totalValue: '总价值'
    },
    recent: {
      title: '最近',
      recentAdditions: '最近添加的项目'
    },
    stats: {
      totalItems: '总项目数',
      totalValue: '总价值',
      totalQuantity: '总数量',
      averagePrice: '平均价格'
    }
  },

  // Settings
  settings: {
    title: '用户设置',
    currency: '货币',
    language: '语言',
    saveSettings: '保存设置',
    settingsSaved: '设置保存成功！',
    settingsError: '保存设置失败',
    currencyDescription: '设置您在应用程序中显示价格的偏好货币。所有价格将转换为您选择的货币。',
    languageDescription: '选择您偏好的应用程序界面语言。语言将立即应用。',
    preferences: '偏好设置'
  },

  // Custom Data
  customData: {
    addNew: '添加新{type}',
    add: '添加',
    adding: '添加中...',
    valueRequired: '需要输入值',
    userNotAuthenticated: '用户未认证',
    addError: '添加自定义数据失败',
    description: '此{type}将添加到您的个人列表中，仅对您可见。',
    enterValue: '输入{type}名称',
    tip: '找不到您的{type}？输入并选择或按Tab键将其添加到您的个人列表中。',
    standard: '标准',
    manageTitle: '管理自定义数据',
    manageDescription: '管理您的个人品牌、系列、类型、比例和来源条目。这些仅对您可见。',
    manageSubtitle: '个人主数据',
    manageSubDescription: '添加和管理您自己的品牌、系列、类型、比例和来源条目，这些不在标准列表中。',
    manageButton: '管理自定义数据',
    loadError: '加载自定义数据失败',
    deleteError: '删除自定义数据失败',
    delete: '删除',
    items: '项目',
    noItems: '还没有自定义{type}项目。',
    customItem: '自定义项目'
  },

  // Auth
  auth: {
    login: {
      title: '登录ToyPort',
      email: '电子邮件',
      password: '密码',
      signIn: '登录',
      signInWithGoogle: '使用Google登录',
      noAccount: '还没有账户？',
      signUp: '注册',
      forgotPassword: '忘记密码？',
      loginError: '登录失败'
    },
    signup: {
      title: '创建您的账户',
      displayName: '显示名称',
      email: '电子邮件',
      password: '密码',
      confirmPassword: '确认密码',
      signUp: '注册',
      signUpWithGoogle: '使用Google注册',
      haveAccount: '已有账户？',
      signIn: '登录',
      signupError: '创建账户失败',
      passwordMismatch: '密码不匹配'
    }
  },

  // Languages
  languages: {
    en: 'English',
    th: 'ไทย',
    ja: '日本語',
    zh: '中文'
  },

  // Wishlist
  wishlist: {
    title: '愿望清单',
    subtitle: '跟踪您想要添加到收藏中的项目',
    addNewWish: '添加愿望项目',
    addFirstWish: '添加您的第一个愿望项目',
    searchPlaceholder: '搜索愿望清单项目...',
    noWishItems: '您的愿望清单中还没有项目。',
    noSearchResults: '未找到符合搜索条件的愿望清单项目。',
    showingResults: '显示 {count} 个，共 {total} 个项目',
    convertToToy: '转换为玩具',
    convert: '是的，我得到了！',
    converting: '转换中...',
    convertConfirm: '您得到了吗？',
    convertConfirmDescription: '这将把此项目从您的愿望清单移动到您的收藏中。之后您可以添加数量和来源信息。',
    deleteConfirm: '删除愿望项目？',
    deleteConfirmDescription: '这将永久删除此愿望项目。此操作无法撤销。',
    // New celebratory conversion messages
    congratulations: '🎉 恭喜！🎉',
    finallyGotIt: '您终于得到了！',
    thatsAwesome: '太棒了！🎊 是时候将这个美丽的项目从您的愿望清单移动到您的收藏中了。您可以添加数量和来源等详细信息。',
    readyToCelebrate: '准备好庆祝这个收藏的新增项目了吗？',
    maybeLater: '稍后再说',
    yesAddToCollection: '🎉 是的，添加到收藏！',
    addingToCollection: '正在添加到收藏...'
  },

  publicCollection: {
    title: 'Shared Collection',
    subtitle: 'Curated by collector {collectorId}',
    backToLanding: 'Back to ToyPort',
    viewOnlyNotice: 'This page is read-only. Prices shown in {currency}.',
    emptyTitle: 'No items to show yet',
    emptyDescription: 'The owner has not added any items or keeps them private.',
    invalidLink: 'This public collection link is invalid.',
    loadError: 'We could not load this collection right now. Please try again later.',
    notShared: 'This collector has not published a public snapshot yet.',
    untitledToy: 'Untitled Toy',
    unknownBrand: 'Unknown brand'
  },

  // Currencies
  currencies: {
    USD: '美元',
    THB: '泰铢',
    JPY: '日元',
    CNY: '人民币'
  }
}; 
